module.exports = __webpack_public_path__ + "static/banner-pic-df7b94b9b68083479842c64d4d5f2573.png";